<script setup lang="ts">
import type { Lesson } from '../../model/lessons/interfaces'

import { faArrowsRotate, faCalendar, faCalendarCircleExclamation, faNoteSticky } from '@fortawesome/pro-regular-svg-icons'

import { AppTooltip } from '@shared/ui/tooltips'
import { LinkTextPrimary } from '@shared/ui/links'
import { AppIcon } from '@shared/ui/icons'

import { LessonScheduleType } from '../../model/lessons/enums'

defineOptions({
  name: 'LessonDate',
})

defineProps<{
  lesson: Lesson
  start: string
  editUrl: string
}>()
</script>

<template>
  <div class="lesson-date">
    <AppTooltip
      v-if="lesson.schedule_type === LessonScheduleType.Single"
      text="Single lesson: off schedule"
    >
      <AppIcon
        :icon="faCalendar"
        color="blue-600"
      />
    </AppTooltip>
    <AppTooltip
      v-else-if="lesson.schedule_type === LessonScheduleType.Regular"
      text="Weekly recurring lesson"
    >
      <AppIcon
        :icon="faArrowsRotate"
        color="blue-600"
      />
    </AppTooltip>
    <LinkTextPrimary :href="editUrl">
      {{ start }}
    </LinkTextPrimary>
    <AppTooltip
      v-if="lesson.tutor_notes"
      :text="lesson.tutor_notes"
    >
      <AppIcon
        :icon="faNoteSticky"
        color="slate-500"
      />
    </AppTooltip>
    <AppTooltip
      v-if="lesson.is_out_of_tutor_schedule"
      text="Out of tutor schedule"
    >
      <AppIcon
        :icon="faCalendarCircleExclamation"
        color="red-600"
      />
    </AppTooltip>
  </div>
</template>

<style scoped lang="scss" src="./LessonDate.scss" />
